export default function RemovedMembersPage() {
  return null
}
